import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { LoaderState } from '../shared/components/loader/loader';

@Injectable()
export class LoaderService {

    private loaderSubject = new Subject<LoaderState>();
    private pendingRequests = 0;
    loaderStateModel: boolean;
    isPost: boolean;
    loaderState = this.loaderSubject.asObservable();

    constructor() { }

    show(isPost: boolean) {
        this.pendingRequests++;
        this.isPost = isPost;
        this.loaderStateModel = true;
        this.loaderSubject.next(<LoaderState>{show: true});

    }

    hide() {
        this.pendingRequests = Math.max(0, this.pendingRequests - 1);
        if (this.pendingRequests === 0) {
            this.loaderStateModel = false;
            this.loaderSubject.next(<LoaderState>{show: false});
        }
    }

    reset() {
        this.pendingRequests = 0;
        this.loaderStateModel = false;
        this.loaderSubject.next(<LoaderState>{show: false});
    }
}
